module.exports = __webpack_public_path__ + "static/img/2016-05-21 16.54.31.71dc531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2016-05-21 16.54.31.jpg
// module id = 57C9
// module chunks = 4